import React from 'react'
import Footer from '../Footer'
import Header from '../Header'
import Newsletter from '../Newsletter'
import Portfolio from '../Portfolio'

const Portfoliopage = () => {
  return (
    <>
      <Header />
      <Portfolio />
      <Newsletter />
      <Footer />
      
    </>
  )
}

export default Portfoliopage
